export default {
    ASC: "ASC",
    DESC: "DESC"
};
